import styled from 'styled-components';

export const CardContainer = styled.div`
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-align: center;
    font-weight: 800;
    font-size: 15px;
    font-style: ExtraBold;
    line-height: 143%;
    letter-spacing: 1.45%;
    @media (max-width: 425px) {
        font-size: 12px;
        font-weight: 600;
    }
`;

export const CardValueContainer = styled.div`
    width: fit-content;
    display: flex;
    gap: 8px;
    font-weight: 800;
    font-style: ExtraBold;
    font-size: 29px;
    line-height: 143%;
    letter-spacing: 1.45%;
    @media (max-width: 1024px) {
        flex-direction: column;
        font-size: 24px;
    }
    @media (max-width: 425px) {
        font-size: 20px;
        font-weight: 600;
    }
`;

export const Alert = styled.div`
    width: fit-content;
    height: fit-content;
    border-radius: 999px;
    padding: 6px 18px;
    background-color: #ff0000;
    color: #ffffff;
    font-weight: 800;
    font-size: 20px;
    font-style: ExtraBold;
    line-height: 143%;
    letter-spacing: 1.45%;
    text-align: center;
    @media (max-width: 425px) {
        font-size: 12px;
        font-weight: 600;
    }
`;
